var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container"},[_c('portal-box',{staticClass:"has-text-centered-fullhd"},[_c('iframe',{attrs:{"width":"100%","height":"480","src":_vm.link,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d87e3698","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/VideoInstitucional/Dashboard.vue
// module id = 2Rn+
// module chunks = 0